
import { Component, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { IdleTimeOutModel } from './idletimeout.model';
import { Observable, Subscription } from 'rxjs/Rx';
import { CommonService } from '../../shared/service/shared.service';
import { SiteLanguageService } from '../../shared/service/site-language.service';
import { SharedModel } from '../../shared/models/shared.model';
 
const IDLE_TIMEOUT_KEYS = {
    titleTimeout: 'yediEminIdleTimeoutTitle',
    messageSessionClosed: 'yediEminIdleTimeoutMessageSessionClosed',
    btnTamam: 'yediEminIdleTimeoutBtnTamam',
    titleIdleWarning: 'yediEminIdleTimeoutTitleIdleWarning',
    hintContinue: 'yediEminIdleTimeoutHintContinue',
    btnLogout: 'yediEminIdleTimeoutBtnLogout',
    btnContinue: 'yediEminIdleTimeoutBtnContinue',
    logoAlt: 'yediEminIdleTimeoutLogoAlt',
};

/** Kaynak eksikse kullanılacak sabit Türkçe varsayılanlar. Dil değişiminde
 *  bileşen alanı fallback olarak verilirse bir önceki dildeki metin kalıcı
 *  olabildiği için sabit tutulur. */
const IDLE_TIMEOUT_DEFAULTS = {
    titleTimeout: 'Zaman Aşımı',
    messageSessionClosed: 'Uzun süredir işlem yapmadığınız için oturumunuz kapatıldı.',
    btnTamam: 'Tamam',
    titleIdleWarning: 'Uzun süredir işlem yapmadınız!',
    hintContinue: 'Devam etmek için lütfen "Devam" butonuna tıklayınız.',
    btnLogout: 'Çıkış',
    btnContinue: 'Devam',
    logoAlt: '',
};

@Component({
    selector: 'idleTimeOut-modal',
    templateUrl: './idletimeout.component.html'
})

export class IdleTimeOutComponent extends SiriusBaseComponent<IdleTimeOutModel> implements OnDestroy {
    @Input() hasTimeOut: boolean;
    @Input() logOutTimeRunOut: boolean;
    @Input() counter: number; 
    @Input() errorText: string;
    @Input() errorTitle: string;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onClickLogout: EventEmitter<any> = new EventEmitter();
    @Output() onClickContinue: EventEmitter<any> = new EventEmitter();
    @Output() logOutWithoutRedirect: EventEmitter<any> = new EventEmitter();
    sub: Subscription;
    /** Dil değişimini dinleyip metinleri tazeleyen abonelik. */
    private langSub: Subscription;
    ticks = 0;
    tempCounter: number;
    counterForCountdown: number = 100;

    titleTimeout = IDLE_TIMEOUT_DEFAULTS.titleTimeout;
    messageSessionClosed = IDLE_TIMEOUT_DEFAULTS.messageSessionClosed;
    btnTamam = IDLE_TIMEOUT_DEFAULTS.btnTamam;
    titleIdleWarning = IDLE_TIMEOUT_DEFAULTS.titleIdleWarning;
    hintContinue = IDLE_TIMEOUT_DEFAULTS.hintContinue;
    btnLogout = IDLE_TIMEOUT_DEFAULTS.btnLogout;
    btnContinue = IDLE_TIMEOUT_DEFAULTS.btnContinue;
    logoAlt = IDLE_TIMEOUT_DEFAULTS.logoAlt;

    constructor(private commonService: CommonService, private siteLanguage: SiteLanguageService) {
        super();

    }

    timeCounter() {
        let timer = Observable.timer(1000, 1000);
        this.sub = timer.subscribe(t => this.tickerFunc(t));
        this.tempCounter = this.counterForCountdown;
    }

    tickerFunc(tick) {
        if (this.tempCounter - 1 > -1) {
            this.tempCounter = this.tempCounter - 1;
        } else {
            this.ngOnDestroy();
            this.logOutTimeRunOut = true;
            this.LogoutWithoutRedirect(event);
        }
    }

    startCounter() {
        this.timeCounter();
    }

    stopCounter() {
        this.sub.unsubscribe();
    }

    OnInit() {
        this.model = new IdleTimeOutModel();
        // Dil BehaviorSubject olduğu için abone olur olmaz mevcut değerle senkron bir kez tetiklenir;
        // dil sonradan değişirse (ör. sunucu syncFromServer ile ENG'e çektiğinde) metinler yenilenir.
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => {
            this.loadIdleTimeoutResourceStrings();
        });
    }

    private loadIdleTimeoutResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.titleTimeout = r(IDLE_TIMEOUT_KEYS.titleTimeout, IDLE_TIMEOUT_DEFAULTS.titleTimeout);
        this.messageSessionClosed = r(IDLE_TIMEOUT_KEYS.messageSessionClosed, IDLE_TIMEOUT_DEFAULTS.messageSessionClosed);
        this.btnTamam = r(IDLE_TIMEOUT_KEYS.btnTamam, IDLE_TIMEOUT_DEFAULTS.btnTamam);
        this.titleIdleWarning = r(IDLE_TIMEOUT_KEYS.titleIdleWarning, IDLE_TIMEOUT_DEFAULTS.titleIdleWarning);
        this.hintContinue = r(IDLE_TIMEOUT_KEYS.hintContinue, IDLE_TIMEOUT_DEFAULTS.hintContinue);
        this.btnLogout = r(IDLE_TIMEOUT_KEYS.btnLogout, IDLE_TIMEOUT_DEFAULTS.btnLogout);
        this.btnContinue = r(IDLE_TIMEOUT_KEYS.btnContinue, IDLE_TIMEOUT_DEFAULTS.btnContinue);
        this.logoAlt = r(IDLE_TIMEOUT_KEYS.logoAlt, IDLE_TIMEOUT_DEFAULTS.logoAlt);
    }

    public close(e: any) {
        //this.onClose.emit(e);
        this.hasTimeOut = false;
    }

    public ClickLogout(e: any) {
        try {
            SharedModel.page = SharedModel.home;
            this.onClickLogout.emit(e);
        } catch{
            this.commonService.redirect();
        }
    }

    public continueFlow(e: any) {
        this.onClickContinue.emit(e);
    }

    public LogoutWithoutRedirect(e: any) {
        this.logOutWithoutRedirect.emit(e);

    }

    public open() {
        this.hasTimeOut = true;
    }

    ngOnDestroy() {
        if (this.sub != undefined) {
            this.sub.unsubscribe();
        }
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }
}
